import { memo } from 'react';
import Link from 'next/link';
import styled from '@emotion/styled';

import { useRsvpIsVisible } from '../lib/useRsvpIsVisible';
import ActionButton from './ActionButton';
import { cx, css } from '@emotion/css';
import useTracking from '../lib/useTracking';
import { useCurrentRoute } from '../lib/useCurrentRoute';
import { useRouteBuilder } from '../lib/hooks/useRouteBuilder';

const B = styled(ActionButton)`
  font-weight: normal;
  margin: 0 auto;

  width: fit-content;
  padding: 0.75rem 1.25rem;
  .verticalLayout.homePage & {
    padding: 0.75rem 3.25rem;
  }
  @media (min-width: 768px) {
    margin: 0 auto;

    .verticalLayout.homePage & {
      margin: 0 0 1rem;
    }
  }
`;

interface RSVPButtonProps {
  title?: string;
  userDecisionArea?: string;
}

function RSVPButton({
  title = 'RSVP',
  userDecisionArea = 'rsvp cta button',
}: RSVPButtonProps) {
  const showRsvp = useRsvpIsVisible();
  const currentRoute = useCurrentRoute();
  const newRoute = useRouteBuilder('rsvp');

  const trackRsvp = useTracking('rsvp', currentRoute, userDecisionArea);

  if (!showRsvp) {
    return null;
  }

  return (
    <Link
      className={cx(css`
        text-decoration: none !important;
      `)}
      href={newRoute}
      as={newRoute}
      onClick={() => trackRsvp('rsvp')}
      data-testid="rsvp-button"
    >
      <B>{title}</B>
    </Link>
  );
}

export default memo(RSVPButton);
